var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card px-4 py-2 lg:px-12 lg:py-8 my-12",attrs:{"id":_vm.slug}},[_c('router-link',{attrs:{"to":`${_vm.$route.path}#${_vm.slug}`}},[_c('VinTitle',{attrs:{"text":_vm.$t(_vm.slug)}})],1),_c('hr',{staticClass:"my-5"}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.markup)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }